import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Select } from '../../Form';

import { Container, Wrapper } from './styles';

const itineraryKeyName = 'common:plan.filter.placeholder';

class Itinerary extends PureComponent {
  constructor(props) {
    super(props);

    const { t } = props;

    this.state = {
      startValue: { name: t(itineraryKeyName) },
      finishValue: { name: t(itineraryKeyName) },
      shop: [
        {
          name: t(itineraryKeyName),
          selected: true,
          disabled: true
        }
      ]
    };

    this.shops = [
      {
        name: t(itineraryKeyName),
        selected: true,
        disabled: true
      }
    ];

    this.unsortedShops = [];
  }

  componentDidMount() {
    const { data, t } = this.props;
    data.map(item => {
      if (item.shop) {
        this.unsortedShops.push(item.shop);
      }
    });

    this.unsortedShops.sort((a, b) => {
      if (a.name === t(itineraryKeyName)) return -1;
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    this.unsortedShops.map(e => {
      this.shops.push(e);
    });

    this.setState({
      shop: this.shop
    });
  }

  static getDerivedStateFromProps(props) {
    const { startValue, finishValue, t } = props;

    if (t) {
      if (
        startValue.label === t(itineraryKeyName) &&
        finishValue.label === t(itineraryKeyName)
      ) {
        return {
          startValue: { name: startValue.label },
          finishValue: { name: finishValue.label }
        };
      }
    }

    return null;
  }

  handleOnChange = (type, event) => {
    const { data, changeValue } = this.props;

    let value = null;
    data.map(item => {
      if (!item.shop) return;
      if (item.shop.name === event.target.value) {
        value = item;
      }
    });

    this.setState({
      [type]: { name: event.target.value }
    });

    changeValue(type, value);
  };

  render() {
    const { startValue, finishValue } = this.state;
    const { t } = this.props;
    return (
      <Container>
        <Wrapper>
          <Select
            icon="event"
            name="shop-destination"
            label={`${t('common:plan.filter.brand.title')} :`}
            onChange={event => this.handleOnChange('finishValue', event)}
            value={finishValue.name}
            data={this.shops}
          />
          <Select
            icon="user"
            name="shop-start"
            label={t('common:plan.filter.direction.title')}
            onChange={event => this.handleOnChange('startValue', event)}
            value={startValue.name}
            data={this.shops}
          />
        </Wrapper>
      </Container>
    );
  }
}

Itinerary.propTypes = {
  data: PropTypes.array.isRequired,
  startValue: PropTypes.object,
  finishValue: PropTypes.object,
  changeValue: PropTypes.func.isRequired
};

export default translate()(Itinerary);
